import React from 'react';

// Orijinal HTML'deki 'contact' bölümünün React component'i
function Iletisim() {
  return (
    // section'a ID veriyoruz ki Navbar'dan link verilebilsin
    <section className="section contact" id="iletisim">
      <div className="container">
        <h2 className="section-title">İletişim</h2>
        <div className="contact-grid">
          
          {/* --- GÜNCELLENDİ --- CEP TELEFONU (Furkan Bey) */}
          <div className="contact-item">
            <div className="contact-icon">📞</div>
            <h3>Furkan ARIKAN</h3>
            <p><a href="tel:05356828841">0535 682 88 41</a></p>
          </div>

          {/* --- YENİ --- İŞ YERİ TELEFONU */}
          <div className="contact-item">
            <div className="contact-icon">☎️</div>
            <h3>İş Yeri</h3>
            <p><a href="tel:02364130033">0236 413 00 33</a></p>
          </div>

          {/* --- GÜNCELLENDİ --- ADRES */}
          <div className="contact-item">
            <div className="contact-icon">📍</div>
            <h3>Adres</h3>
            <p>Paşa Mah. 26 Sk. No: 36/A</p>
            <p>Akhisar, Manisa</p>
          </div>
          
          {/* --- YENİ --- INSTAGRAM */}
          <div className="contact-item">
            <div className="contact-icon">📸</div>
            <h3>Instagram</h3>
            <p>
              <a 
                href="https://www.instagram.com/arasgayrimenkulll?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                @arasgayrimenkul
              </a>
            </p>
          </div>

        </div>
        <div className="text-center">
          {/* WhatsApp linkini cep telefonuna yönlendiriyoruz */}
          <a 
            href="https://wa.me/905356828841" 
            className="whatsapp-btn" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            WhatsApp ile İletişime Geç
          </a>
        </div>
      </div>
    </section>
  );
}

export default Iletisim;